<template>
    <v-dialog v-model="dialog" max-width="1000" scrollable>
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>Edit User</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            
            <v-container fluid grid-list-md>
                <v-flex xs12 class="text-xs-left">
                    <v-form ref="form" lazy-validation>
                        <v-select v-model="form.merchantUuid" multiple small-chips :items="merchants" item-text="name" item-value="uuid" label="Companies" :rules="rules.multiSelect" ></v-select>
                        <v-text-field v-model="form.username" readonly label="Username"></v-text-field>
                        <v-text-field v-model="form.firstName" label="First Name" :rules="rules.required" ></v-text-field>
                        <v-text-field v-model="form.surname" label="Surname" :rules="rules.required" required></v-text-field>
                        <v-select v-model="form.pageAccess" :menu-props="{ top: true, offsetY: true }" small-chips multiple :items="pageAccess" item-text="page_name" item-value="page_access" label="Page Access" :rules="rules.multiSelect" ></v-select>
                        <v-select v-model="form.subPageAccess" :menu-props="{ top: true, offsetY: true }" small-chips return-object multiple :items="subPageAccess" item-text="sub_page_name" item-value="sub_page_access" label="Sub Page Access"></v-select>

                        <v-card-actions class="pa-0 pt-2">
                            <v-btn color="primary" @click="updateUser()">Update</v-btn>
                            <v-btn color="primary" @click="resetPassword()">Reset Password</v-btn>
                            <v-btn color="error" @click="deleteUser()">Delete User</v-btn>
                            
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="dialog = false">Close</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-flex>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import sweetAlert from '../sweetAlert.js';

export default {
    data() {
        return {
            rules: { required: [ v => !!v || 'Required' ],
                     email: [ v => this.emailRule(v) ],
                     multiSelect: [ v => this.multiSelect(v) ],
                     username: [ v => this.username(v) ] },
            form: { merchantUuid: '',
                    email: null,
                    firstName: null,
                    surname: null,
                    pageAccess: [],
                    subPageAccess: [] }
        }
    },
    props: {
        visible: Boolean,
        userData: Object,
        merchants: Array,
        users: Array,
        pageAccess: Array,
        subPageAccess: Array
    },
    mixins: [ sweetAlert ],
    computed: {
        dialog: {
            get() {
                if(this.visible) {
                    this.form.merchantUuid = this.userData.merchant_access.split(',')
                    this.form.username = this.userData.username;
                    this.form.firstName = this.userData.first_name;
                    this.form.surname = this.userData.surname;
                    this.getPageAccess();
                    this.getSubPageAccess();
                    this.loadDialog = true;
                    // this.form.pageAccess = this.userData.page_access.split(',');
                    // this.form.subPageAccess = this.userData.sub_page_access ? this.userData.sub_page_access : null;
                }
                return this.visible ? true : false;
            },
            set(v) {
                if(!v) {
                    this.$emit('closeDialog');
                }
            }
        }
    },
    mounted() {
        
    },
    methods: {
        updateUser() {
            if(this.$refs.form.validate()) {
                console.log(this.form);
                if(!this.form.pageAccess.includes(1) && !this.form.pageAccess.includes(10)) {
                    this.form.pageAccess.push(1,10);
                }

                let temp = [];
                if(this.form.subPageAccess != null) {
                    this.form.subPageAccess.map((i) => {
                        if(!this.form.pageAccess.includes(i.parent_id)) {
                            this.form.pageAccess.push(i.parent_id);
                        }
                        temp.push(i.sub_page_access);
                    });
                }
                
                this.form.pageAccessComma = this.form.pageAccess.join(",");
                this.form.subPageAccessComma = temp.length > 0 ? temp.join(",") : null;
                this.form.merchantUuidComma = this.form.merchantUuid.join('","');

                console.log(this.form.pageAccessComma);
                console.log(this.form.subPageAccessComma);
                
                axios({
                method: 'post',
                data: { form: this.form, userId: this.userData.id },
                url: 'https://controlapi.totalprocessing.com/api/edit-user',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    let result = {};
                    console.log(response);
                    this.$emit('getUsers');
                    if(response.status == 201) {
                        result.user = 'edit-user-success';
                    }
                    else {
                        result.user = 'edit-user-failed';
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        resetPassword() {
            axios({
            method: 'post',
            data: { userId: this.userData.id },
            url: 'https://controlapi.totalprocessing.com/api/reset-user-password',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                let result = {};
                console.log(response);
                if(response.status == 200) {
                    result.user = 'reset-user-success';
                }
                else {
                    result.user = 'reset-user-failed';
                }
                this.sweetAlert(result);
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        deleteUser() {
            axios({
            method: 'post',
            data: { userId: this.userData.id },
            url: 'https://controlapi.totalprocessing.com/api/delete-user',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                let result = {};
                console.log(response);
                this.$emit('getUsers');
                if(response.status == 204) {
                    result.user = 'delete-user-success';
                }
                else {
                    result.user = 'delete-user-failed';
                }
                this.sweetAlert(result);
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getPageAccess() {
            axios({
            method: 'post',
            data: { userId: this.userData.id },
            url: 'https://controlapi.totalprocessing.com/api/get-page-access',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.form.pageAccess = response.data.map(e => e.page_access);
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getSubPageAccess() {
            axios({
            method: 'post',
            data: { userId: this.userData.id },
            url: 'https://controlapi.totalprocessing.com/api/get-sub-page-access',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.form.subPageAccess = response.data;
                response.data.map(e => {
                    e.sub_page_name = `${e.page_name} - ${e.sub_page_name}`;
                });
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        emailRule(v) {
            let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(typeof v !== 'undefined' && v)
            {   if(!pattern.test(v)) {
                    return 'Invalid Email address';
                }
                else { 
                    return true;
                }
            } 
            else {
                return true;
            }
        },
        multiSelect(v) {
            return (v && v.length) > 0 ? true : 'Required';
        },
        username(v) {
            return this.users.find(user => user.username.toLowerCase() === v) ? 'Username already exists' : this.emailRule(v);
        }
    }
}
</script>